import React from 'react';
import { ScatterChartContext } from '@/context/indicators/scatter.chart.context';

export function useScatter() {
  return React.useContext(ScatterChartContext);
}
